export default "__VITE_ASSET__ea6affe7__"